module.exports = __webpack_public_path__ + "static/media/dsp_background_mb.cb6aa5b1.png";